import { render, staticRenderFns } from "./WriteIcon.vue?vue&type=template&id=3c3e5969&"
import script from "./WriteIcon.vue?vue&type=script&lang=js&"
export * from "./WriteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports